export const FORM_UPDATE = 'FORM_UPDATE';
export const FORM_UNSET = 'FORM_UNSET';

export default {
  FORM_UPDATE,
  FORM_UNSET
};
